import React, { SyntheticEvent, useContext, useEffect, useState } from 'react'
import { ThemeProvider } from '@emotion/react'
import styles from './ErrorDashboard.module.css'
import { FormControl, MenuItem, Tab, Tabs, createTheme } from '@mui/material'
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { useForm } from 'react-hook-form';
import DateInputWithForm from '../../components/shared-components/datepicker/DateInputWithForm';
import ToasterWithMessage from '../../components/shared-components/toaster';
import AddTicketsError from '../../components/shared-components/error-dashboard/AddTicketsError';
import SoldTicketsError from '../../components/shared-components/error-dashboard/SoldTicketsError';
import StripePaymentsError from '../../components/shared-components/error-dashboard/StripePaymentsError';
import ScrapeEventError from '../../components/shared-components/error-dashboard/ScrapeEventError';
import { globalContext } from '../../Provider/AppProvider';
import { GET_NOTIFICATIONS } from '../../components/shared-components/notification/api/NotificationQuery';
import { useLazyQuery } from '@apollo/client';
import { StyledSelectDropdownforError, canViewMailParserExtendedTabs, getDayBeforeYesterday, getToday, oneMonthAgo, roles } from '../../helper';
import { getNotificationQueryVariables } from '../../utils/notification-query-variables';
import StripePayoutError from '../../components/shared-components/error-dashboard/StripePayoutError';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import PublishTicketsError from '../../components/shared-components/error-dashboard/PublishTicketsError';
import UserTicketsLog from '../../components/shared-components/error-dashboard/UserTicketsLog';
import ControlPointIcon from '@mui/icons-material/ControlPoint';

const CustomSelect = StyledSelectDropdownforError()

const ErrorDashboard = () => {

  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  localStorage.removeItem('ticketsTabIndex');
  localStorage.removeItem('settingsTabIndex');
  const tab=localStorage?.getItem('errorTabIndex');
  const [errorActiveTab, setErrorActiveTab] = useState<number>(localStorage.getItem('errorTabIndex')&&tab?parseInt(tab):0);
  const [selectedStartDate, setSelectedStartDate] = useState(getDayBeforeYesterday());
  const [selectedEndDate, setSelectedEndDate] = useState(getToday());
  const [datesForApiCall, setDatesForApiCall] = useState({ fromdate: getDayBeforeYesterday(), enddate: getToday() });
  const [selectedStartDateForPublishError, setSelectedStartDateForPublishError] = useState(getDayBeforeYesterday());
  const [selectedEndDateForPublishError, setSelectedEndDateForPublishError] = useState(getToday());
  const [datesForApiCallForPublishError, setDatesForApiCallForPublishError] = useState({ fromdate: getDayBeforeYesterday(), enddate: getToday() });
  const [selectedStartDateForSoldError, setSelectedStartDateForSoldError] = useState(getDayBeforeYesterday());
  const [selectedEndDateForSoldError, setSelectedEndDateForSoldError] = useState(getToday());
  const [datesForApiCallForSoldError, setDatesForApiCallForSoldError] = useState({ fromdate: getDayBeforeYesterday(), enddate: getToday() });
  const [datesForApiCallForManualTicketsError, setDatesForApiCallForManualTicketsError] = useState({ fromdate: getDayBeforeYesterday(), enddate: getToday() });
  const [tempRowsPerPage, setTempRowsPerPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(parseInt(tempRowsPerPage ? tempRowsPerPage : '') || 10);
  const [tempRowsPerPagePublish, setTempRowsPerPagePublish] = useState();
  const [rowsPerPagePublish, setRowsPerPagePublish] = useState(parseInt(tempRowsPerPagePublish ? tempRowsPerPagePublish : '') || 10);
  const [tempRowsPerPageSold, setTempRowsPerPageSold] = useState();
  const [rowsPerPageSold, setRowsPerPageSold] = useState(parseInt(tempRowsPerPageSold ? tempRowsPerPageSold : '') || 10);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagePublish, setCurrentPagePublish] = useState(1);
  const [currentPageSold, setCurrentPageSold] = useState(1);
  const [checking,setChecking]=useState<boolean>(false);
  const [currentPageStripe, setCurrentPageStripe] = useState(1);
  const [currentPageScrape, setCurrentPageScrape] = useState(1);
  const [currentPageStripepayout, setCurrentPageStripepayout] = useState(1);
  const [currentPageManualTicket, setCurrentPageManualTicket] = useState(1);
  const [tempRowsPerPageStripe, setTempRowsPerPageStripe] = useState();
  const [rowsPerPageStripe,setRowsPerPageStripe] = useState(parseInt(tempRowsPerPageStripe ? tempRowsPerPageStripe : '') || 10);

  const [selectedStartDateForStripeError, setSelectedStartDateForStripeError] = useState(getDayBeforeYesterday());
  const [selectedEndDateForStripeError, setSelectedEndDateForStripeError] = useState(getToday());
  const [datesForApiCallForStripeError, setDatesForApiCallForStripeError] = useState({ fromdate: getDayBeforeYesterday(), enddate: getToday() });

  const [tempRowsPerPageStripepayout, setTempRowsPerPageStripepayout] = useState();
  const [rowsPerPageStripepayout, setRowsPerPageStripepayout] = useState(parseInt(tempRowsPerPageStripepayout ? tempRowsPerPageStripepayout : '') || 10);
  const [selectedStartDateForStripepayoutError, setSelectedStartDateForStripepayoutError] = useState(getDayBeforeYesterday());
  const [selectedEndDateForStripepayoutError, setSelectedEndDateForpayoutStripeError] = useState(getToday());
  const [datesForApiCallForStripepayoutError, setDatesForApiCallForStripepayoutError] = useState({ fromdate: getDayBeforeYesterday(), enddate: getToday() });

  const [tempRowsPerPageScrape, setTempRowsPerPageScrape] = useState();
  const [rowsPerPageScrape, setRowsPerPageScrape] = useState(parseInt(tempRowsPerPageScrape ? tempRowsPerPageScrape : '') || 10);
  const [selectedStartDateForScrapeError, setSelectedStartDateForScrapeError] = useState(getDayBeforeYesterday());
  const [selectedEndDateForScrapeError, setSelectedEndDateForScrapeError] = useState(getToday());
  const [datesForApiCallForScrapeError, setDatesForApiCallForScrapeError] = useState({ fromdate: getDayBeforeYesterday(), enddate: getToday() });

  const [tempRowsPerPageManualTicket, setTempRowsPerPageManualTicket] = useState();
  const [rowsPerPageManualTicket,setRowsPerPageManualTicket] = useState(parseInt(tempRowsPerPageManualTicket ? tempRowsPerPageManualTicket : '') || 10);
  const [selectedStartDateForManualTicketError,setSelectedStartDateForManualTicketError] = useState(getDayBeforeYesterday());
  const [selectedEndDateForManualTicketError,setSelectedEndDateForManualTicketError] = useState(getToday());

  const [addTicketErrorList,setAddTicketErrorList] = useState<any>([{}]);
  const [publishTicketErrorList,setPublishTicketErrorList] = useState<any>([{}]);
  const [soldTicketErrorList,setSoldTicketErrorList] = useState<any>([{}]);
  const [stripePaymentsErrorList,setStripePaymentsErrorList] = useState<any>([{}]);
  const [stripePaymentsErrorpayoutList,setStripePaymentspayoutErrorList] = useState<any>([{}]);
  const [scrapeEventErrorList,setScrapeEventErrorList] = useState<any>([{}]);
  const [manualTicketErrorList,setManualTicketErrorList] = useState<any>([{}]);

  const [columnTypesForAdd, setColumnTypesForAdd] = useState('');
  const [columnTypesForPublish, setColumnTypesForPublish] = useState('');
  const [columnTypesForSold, setColumnTypesForSold] = useState('');
  const [columnTypesForStripe, setColumnTypesForStripe] = useState('se_date');
  const [columnTypesForStripepayout, setColumnTypesForStripepayout] = useState(globalState.errorStatus.stripePayout==="Failed"?'pe_created_at':'ps_created_at');
  const [columnTypesForScrape, setColumnTypesForScrape] = useState('ee_name');
  const [columnTypesForManualTickets, setColumnTypesForManualTickets] = useState('created_at');



  const [sortType, setSortType] = useState('desc');
  const [selected, setSelected] = useState<number[]>([]);
  const monthStartDate = moment(getDayBeforeYesterday()).format('YYYY-MM-DD');
  const todayDate = moment(getToday()).format('YYYY-MM-DD');
  const {error} = ToasterWithMessage();
  const [selectedValue, setSelectedValue] = useState('');

  const handleChangeErrorActiveTab = (_e: SyntheticEvent, newValue: number) => {
    setSelectedValue(globalState.errorStatus.addTicket)
    setErrorActiveTab(newValue);
    localStorage.setItem('errorTabIndex',String(newValue));
  }

  const [getNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempState = {...globalState}
      tempState.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempState.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempState)
    }
  })

  useEffect(()=>{
    const tempValue = {...globalState};
    if(globalState.globalSearch.affiliateUsersClicked){
      tempValue.globalSearch.searchtext = "";
      tempValue.globalSearch.affiliateUsersClicked = false;
    }
    if(globalState.notification.notificationClicked){
      tempValue.notification.notificationClicked = false;
      tempValue.notification.tp_id_array=null;
      tempValue.globalSearch.searchtext = "";
      tempValue.notification.text = "";
      tempValue.notification.ticketId =null;
      tempValue.notification.tpId = null;
    }else if(globalState.error.errorClicked){
      tempValue.error.errorClicked = false;
      tempValue.globalSearch.searchtext = "";
      tempValue.error.text = "";
      tempValue.error.approximateTpArray = null
      tempValue.error.ticketPlacementId = null
      tempValue.error.status =""
    }
    handleGlobalState(tempValue);
    getNotification({
      variables: getNotificationQueryVariables(globalState?.profile?.id),
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const defaultValues: any = {
    fromDate: monthStartDate,
    toDate: todayDate,
  };

  const { control, setValue,reset } = useForm<any>({
    defaultValues,
    shouldUnregister: false,
  });

  const errorDashboardTheme = createTheme({
    palette: {
      primary: {
        main: "#5D75F8",
      },
    },
    components: {
      MuiTab: {
        styleOverrides: {
          root: {
            fontFamily: "Glegoo",
            fontWeight: 700,
            fontSize: "14px",
            textTransform: "capitalize",
            padding :"5px 8px" 
          },
        },
      },
    },
  });
  const DATE_FORMAT = 'YYYY-MM-DD'
  const dateValidation = (e:any, type:string,errorTab: number) => {
    const {fromDate,toDate} = control._formValues;
    const formattedFromDate = moment(fromDate, DATE_FORMAT);
    const formattedToDate = moment(toDate, DATE_FORMAT);
    if(formattedFromDate.isSameOrBefore(formattedToDate,'day')){
      if(type === 'fromDate'){
        switch(errorTab){
          case 0: setSelectedStartDate(fromDate); break;
          case 1: setSelectedStartDateForPublishError(fromDate);break;
          case 2: setSelectedStartDateForSoldError(fromDate);break;
          case 3: setSelectedStartDateForStripeError(fromDate); break;
          case 4: setSelectedStartDateForStripepayoutError(fromDate); break;
          case 5: setSelectedStartDateForManualTicketError(fromDate); break;
          case 6: setSelectedStartDateForScrapeError(fromDate); break;
          case 7:  break;

          default: break;
        }
       
      }else {
        switch(errorTab){
          case 0: setSelectedEndDate(toDate); break;
          case 1: setSelectedEndDateForPublishError(toDate); break;
          case 2: setSelectedEndDateForSoldError(toDate); break;
          case 3: setSelectedEndDateForStripeError(toDate); break;
          case 4: setSelectedEndDateForpayoutStripeError(toDate); break;
          case 5: setSelectedEndDateForManualTicketError(toDate); break;
          case 6: setSelectedEndDateForScrapeError(toDate); break;
          case 7:  break;
          default: break;
        } 
       }
      setValue("fromDate", formattedFromDate.format(DATE_FORMAT));
      setValue("toDate", formattedToDate.format(DATE_FORMAT));
      switch(errorTab){
        case 0: setDatesForApiCall({
                  fromdate: fromDate,
                  enddate: toDate,
                });
                setCurrentPage(1); break;
        case 1: setDatesForApiCallForPublishError({
                  fromdate: fromDate,
                  enddate: toDate
                });
                setCurrentPagePublish(1); break;
        case 2: setDatesForApiCallForSoldError({
                  fromdate: fromDate,
                  enddate: toDate
                });
                setCurrentPageSold(1); break;
        case 3: setDatesForApiCallForStripeError({
                  fromdate: fromDate,
                  enddate: toDate
                });
                setCurrentPageStripe(1); break;
        case 4: setDatesForApiCallForStripepayoutError({
                  fromdate: fromDate,
                  enddate: toDate
                });
                setCurrentPageStripepayout(1); break;
        case 5: setDatesForApiCallForManualTicketsError({
                  fromdate: fromDate,
                  enddate: toDate
                });
                setCurrentPageManualTicket(1); break;
        case 6: setDatesForApiCallForScrapeError({
                  fromdate: fromDate,
                  enddate: toDate
                });
                setCurrentPageScrape(1); break;
        case 7: break;
        default: break;
      }
  
     
    }else if(formattedFromDate.isAfter(formattedToDate,'day')){
      error("From date must be less than to date")
      switch(errorTab){
        case 0: setDatesForApiCall({
                  fromdate: getDayBeforeYesterday(),
                  enddate: getToday()
                });
                setCurrentPage(1); break;
        case 1: setDatesForApiCallForPublishError({
                  fromdate: getDayBeforeYesterday(),
                  enddate: getToday()
                });
                setCurrentPagePublish(1); break;
        case 2: setDatesForApiCallForSoldError({
                  fromdate: getDayBeforeYesterday(),
                  enddate: getToday()
                });
                setCurrentPageSold(1); break;
        case 3: setDatesForApiCallForStripeError({
                  fromdate:getDayBeforeYesterday() ,
                  enddate: getToday()
                });
                setCurrentPageStripe(1); 
                break;
        case 4: setDatesForApiCallForStripepayoutError({
                  fromdate: getDayBeforeYesterday(),
                  enddate: getToday()
                }); 
                setCurrentPageStripepayout(1);
                break;
        case 5: setDatesForApiCallForManualTicketsError({
                  fromdate: getDayBeforeYesterday(),
                  enddate: getToday()
                });
                setCurrentPageManualTicket(1); break;
        case 6: setDatesForApiCallForScrapeError({
                  fromdate: getDayBeforeYesterday(),
                  enddate: getToday()
                });
                setCurrentPageScrape(1); break;
        case 7: break;
        default: break;
      }
      
      if(type === 'fromDate'){
        setValue("fromDate",defaultValues.fromDate);
        setValue("toDate",defaultValues.toDate);
        switch(errorTab){
          case 0: setSelectedStartDate(getDayBeforeYesterday()); setSelectedEndDate(getToday()); break;
          case 1: setSelectedStartDateForPublishError(getDayBeforeYesterday()); setSelectedEndDateForPublishError(getToday()); break;
          case 2: setSelectedStartDateForSoldError(getDayBeforeYesterday()); setSelectedEndDateForSoldError(getToday()); break;
          case 3: {
                  setSelectedStartDateForStripeError(getDayBeforeYesterday());  
                  setSelectedEndDateForStripeError(getToday());
                  break;
          }
          case 4: {
            setSelectedStartDateForStripepayoutError(getDayBeforeYesterday());  
            setSelectedEndDateForpayoutStripeError(getToday());
            break;
         }
          case 5: setSelectedStartDateForScrapeError(getDayBeforeYesterday()); setSelectedEndDateForScrapeError(getToday());  break;
          case 6: setSelectedStartDateForManualTicketError(getDayBeforeYesterday()); setSelectedEndDateForManualTicketError(getToday());  break;
          case 7: break;
          default: break;
        }
        
      }else{
        setValue("toDate",defaultValues.toDate);
        switch(errorTab){
          case 0: setSelectedEndDate(new Date()); break;
          case 1: setSelectedEndDateForPublishError(new Date()); break;
          case 2: setSelectedEndDateForSoldError(new Date()); break;
          case 3: setSelectedEndDateForStripeError(new Date()); break;
          case 4: setSelectedEndDateForpayoutStripeError(new Date()); break;
          case 5: setSelectedEndDateForManualTicketError(new Date()); break;
          case 6: setSelectedEndDateForScrapeError(new Date()); break;
          case 7: break;
          default: break;
        }
       
      }
      return;
    }
  }


  useEffect(() => {
    // setValue("fromDate", defaultValues.fromDate);
    // setValue("toDate", defaultValues.toDate);
    setSelectedStartDate(getDayBeforeYesterday());
    setSelectedEndDate(getToday());
    setSelectedStartDateForPublishError(getDayBeforeYesterday());
    setSelectedEndDateForPublishError(getToday());
    setSelectedStartDateForSoldError(getDayBeforeYesterday());
    setSelectedEndDateForSoldError(getToday());
    setSelectedStartDateForStripeError(getDayBeforeYesterday());
    setSelectedEndDateForStripeError(getToday());
    setSelectedStartDateForStripepayoutError(getDayBeforeYesterday());
    setSelectedEndDateForpayoutStripeError(getToday());
    setSelectedStartDateForManualTicketError(getDayBeforeYesterday());
    setSelectedEndDateForManualTicketError(getToday());
    setSelectedStartDateForScrapeError(getDayBeforeYesterday());
    setSelectedEndDateForScrapeError(getToday());
    reset();
    setDatesForApiCall({
      fromdate: getDayBeforeYesterday(),
      enddate: getToday()
    }) 
    setDatesForApiCallForPublishError({
      fromdate: getDayBeforeYesterday(),
      enddate: getToday()
    }) 
    setDatesForApiCallForSoldError({
      fromdate: getDayBeforeYesterday(),
      enddate: getToday()
    }) 
    setDatesForApiCallForStripeError({
      fromdate: getDayBeforeYesterday(),
      enddate: getToday()
    })
    setDatesForApiCallForStripepayoutError({
      fromdate: getDayBeforeYesterday(),
      enddate: getToday()
    })
    setDatesForApiCallForManualTicketsError({
      fromdate: getDayBeforeYesterday(),
      enddate: getToday()
    })
    setDatesForApiCallForScrapeError({
      fromdate: getDayBeforeYesterday(),
      enddate: getToday()
    })
    setCurrentPage(1);
    setCurrentPagePublish(1);
    setCurrentPageScrape(1);
    setCurrentPageSold(1);
    setCurrentPageStripe(1);
    setCurrentPageStripepayout(1);
    setCurrentPageManualTicket(1);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[errorActiveTab])

  /* For get the ManageTicket table headers */
  const GenerateAddTicketsErrorHeadCells = ()=>{
    const id = globalState.errorStatus.addTicket === 'Failed' ? globalState.profile.userRole==="logitix_user"?["eventName","eventDate","eventAddress","reason","occurringDate","tp_section","action"]:["eventName","eventDate","eventAddress","reason","occurringDate","tp_section","userName","userEmail","action"] : globalState.profile.userRole==="logitix_user"?["eventName","eventDate","eventAddress","occurringDate","tp_section","reason","action"]:["eventName","eventDate","eventAddress","occurringDate","tp_section","reason","userName","userEmail","action"] ;
    const labels =globalState.errorStatus.addTicket === 'Failed'? globalState.profile.userRole==="logitix_user"?["Event Name","Event Date","Event Address","Reason","Received Date","Ticket Placements,Section,Row,Seat","Action"]:["Event Name","Event Date","Event Address","Reason","Received Date","Ticket Placements,Section,Row,Seat","User Name","Email","Action"] :globalState.profile.userRole==="logitix_user"?["Event Name","Event Date","Event Address","Received Date","Ticket Placements,Section,Row,Seat","Notes","Action"]:["Event Name","Event Date","Event Address","Received Date","Ticket Placements,Section,Row,Seat", "Notes","User Name","Email","Action"];
    const headCells = id.map((id, index) => ({
        id,
        label: labels[index],
      }));
      return headCells;
}

const GeneratePublishTicketsErrorHeadCells = ()=>{
  const id = globalState.errorStatus.publishTicket === 'Failed'? globalState.profile.userRole==="logitix_user"?["eventName","eventDate","eventAddress","reason","occurringDate","tp_section","ticketListPrice","action"]:["eventName","eventDate","eventAddress","reason","occurringDate","tp_section","ticketListPrice","userName","userEmail","action"] :globalState.profile.userRole==="logitix_user"?["eventName","eventDate","eventAddress","occurringDate","tp_section","ticketListPrice","reason","action"]:["eventName","eventDate","eventAddress","occurringDate","tp_section", "ticketListPrice","reason","userName","userEmail","action"] ;
  const labels = globalState.errorStatus.publishTicket === 'Failed' ?globalState.profile.userRole==="logitix_user"? ["Event Name","Event Date","Event Address","Reason","Received Date","Ticket Placements,Section,Row,Seat","List Price","Action"]:["Event Name","Event Date","Event Address","Reason","Received Date","Ticket Placements,Section,Row,Seat","List Price","User Name","Email","Action"] :globalState.profile.userRole==="logitix_user"?["Event Name","Event Date","Event Address","Received Date","Ticket Placements,Section,Row,Seat", "List Price", "Notes","Action"]:["Event Name","Event Date","Event Address","Received Date","Ticket Placements,Section,Row,Seat","List Price", "Notes","User Name","Email","Action"]  ;
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}

const GenerateSoldTicketsErrorHeadCells = ()=>{
  const id = globalState.errorStatus.soldTicket === 'Failed'?globalState.profile.userRole==="logitix_user"? ["eventName","eventDate","eventAddress","reason","occurringDate","tp_section","action"]:["eventName","eventDate","eventAddress","reason","occurringDate","tp_section","userName","userEmail","action"] :globalState.profile.userRole==="logitix_user"?["eventName","eventDate","eventAddress","occurringDate","tp_section", "reason","action"]:["eventName","eventDate","eventAddress","occurringDate","tp_section", "reason","userName","userEmail","action"] ;
  const labels = globalState.errorStatus.soldTicket === 'Failed' ?globalState.profile.userRole==="logitix_user"?["Event Name","Event Date","Event Address","Reason","Received Date","Ticket Placements,Section,Row,Seat","Action"]: ["Event Name","Event Date","Event Address","Reason","Received Date","Ticket Placements,Section,Row,Seat","User Name","Email","Action"] :globalState.profile.userRole==="logitix_user"?["Event Name","Event Date","Event Address","Received Date","Ticket Placements,Section,Row,Seat","Notes","Action"]:["Event Name","Event Date","Event Address","Received Date","Ticket Placements,Section,Row,Seat","Notes","User Name","Email","Action"]  ;
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}

const GenerateStripePaymentsErrorHeadCells = ()=>{
  const id = ["pt_id","u_full_name","u_email_id","se_reason","se_date","e_name","e_date","tp_section"];
  const labels = ["Transaction ID","User Name","Email","Reason","Received Date","Event Name","Event Date","Ticket Placements,Section,Row,Seat"];
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}

const GenerateStripePayoutErrorHeadCells = ()=>{
  const id = ["u_first_name","u_last_name","u_email_id","pe_reason","pe_created_at","pe_amount", "pe_status"];
  const labels = ["First Name", "Last Name", "Email Id", "Reason", "Received Date","Payout Amount", "Error Status"]
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}
const GenerateStripePayoutSuccessHeadCells = ()=>{
  const id = ["u_first_name","u_last_name","u_email_id","ps_created_at","ps_amount"];
  const labels = ["First Name", "Last Name", "Email Id", "Received Date","Payout Amount"]
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}

const GenerateManualTicketsErrorHeadCells = ()=>{
  const id = ["e_name","e_date","e_address","reason","created_at","tp_section","u_full_name","u_email_id"];
  const labels =["Event Name","Event Date","Event Address","Reason","Received Date","Ticket Placements,Section,Row,Seat","User Name","Email"];
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}

const GenerateScrapeEventErrorHeadCells = ()=>{
  const id = ["ee_name","ee_reason","ee_created_at",'ee_created_at'];
  const labels = ["Name","Reason","Date","Time"];
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}

const handleChangeRowsPerPage = (event: any) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setTempRowsPerPage(event.target.value);
  setSelected([]);
  setCurrentPage(1);
};

const handleChangeRowsPerPageForPublishTicket = (event: any) => {
  setRowsPerPagePublish(parseInt(event.target.value, 10));
  setTempRowsPerPagePublish(event.target.value);
  setSelected([]);
  setCurrentPagePublish(1);
};

const handleChangeRowsPerPageForSoldTicket = (event: any) => {
  setRowsPerPageSold(parseInt(event.target.value, 10));
  setTempRowsPerPageSold(event.target.value);
  setSelected([]);
  setCurrentPageSold(1);
};

const handleChangeRowsPerPageForStripe = (event: any) => {
  setRowsPerPageStripe(parseInt(event.target.value, 10));
  setTempRowsPerPageStripe(event.target.value);
  setSelected([]);
  setCurrentPageStripe(1);
};

const handleChangeRowsPerPageForStripepayout = (event: any) => {
  setRowsPerPageStripepayout(parseInt(event.target.value, 10));
  setTempRowsPerPageStripepayout(event.target.value);
  setSelected([]);
  setCurrentPageStripepayout(1);
};

const handleChangeRowsPerPageForManualTickets = (event: any) => {
  setRowsPerPageManualTicket(parseInt(event.target.value, 10));
  setTempRowsPerPageManualTicket(event.target.value);
  setSelected([]);
  setCurrentPageManualTicket(1);
};

const handleChangeRowsPerPageForScrape = (event: any) => {
  setRowsPerPageScrape(parseInt(event.target.value, 10));
  setTempRowsPerPageScrape(event.target.value);
  setSelected([]);
  setCurrentPageScrape(1);
};

const handlePageChange = (_event: React.ChangeEvent, newPage: number) => {
  setCurrentPage(newPage);
  setSelected([]);
  setChecking(false)
};

const handlePageChangePublishTicket = (_event: React.ChangeEvent, newPage: number) => {
  setCurrentPagePublish(newPage);
  setSelected([]);
  setChecking(false)
};

const handlePageChangeSoldTicket = (_event: React.ChangeEvent, newPage: number) => {
  setCurrentPageSold(newPage);
  setSelected([]);
  setChecking(false)
};

const handlePageChangeStripe = (_event: React.ChangeEvent, newPage: number) => {
  setCurrentPageStripe(newPage);
  setSelected([]);
  setChecking(false)
};

const handlePageChangeStripepayout = (_event: React.ChangeEvent, newPage: number) => {
  setCurrentPageStripepayout(newPage);
  setSelected([]);
  setChecking(false)
};

const handlePageChangeScrape = (_event: React.ChangeEvent, newPage: number) => {
  setCurrentPageScrape(newPage);
  setSelected([]);
  setChecking(false)
};

const handlePageChangeManualTicket = (_event: React.ChangeEvent, newPage: number) => {
  setCurrentPageManualTicket(newPage);
  setSelected([]);
  setChecking(false)
};

const setSelectedDateValue = (dateType: string) => {
  let selectedDate;
  switch(errorActiveTab){
    case 0: dateType === 'fromdate' ? selectedDate = selectedStartDate : selectedDate = selectedEndDate; break;
    case 1: dateType === 'fromdate' ? selectedDate = selectedStartDateForPublishError : selectedDate = selectedEndDateForPublishError; break;
    case 2: dateType === 'fromdate' ? selectedDate = selectedStartDateForSoldError : selectedDate = selectedEndDateForSoldError; break;
    case 3: dateType === 'fromdate' ? selectedDate = selectedStartDateForStripeError : selectedDate = selectedEndDateForStripeError; break;
    case 4: dateType === 'fromdate' ? selectedDate = selectedStartDateForStripepayoutError : selectedDate = selectedEndDateForStripepayoutError; break;
    case 5: dateType === 'fromdate' ? selectedDate = selectedStartDateForManualTicketError : selectedDate = selectedEndDateForManualTicketError; break;
    case 6: dateType === 'fromdate' ? selectedDate = selectedStartDateForScrapeError : selectedDate = selectedEndDateForScrapeError; break;
    case 7: break;
    default: break;
  }
  return selectedDate;
}

const emailOutlinedIcon = (tabNumber: number) => {
  return <EmailOutlinedIcon style={{ color: tabNumber === errorActiveTab ? "#5D75F8" : '#80808042', marginRight: '5px' }} />
}

const UserTicketsIcon = (tabNumber: number) => {
  return <ControlPointIcon style={{ color: tabNumber === errorActiveTab ? "#5D75F8" : '#80808042', marginRight: '5px' }} />
} 

const stripeOutlinedIcon = (tabNumber: number) => {
  return <MonetizationOnOutlinedIcon style={{ color: tabNumber === errorActiveTab ? "#5D75F8" : '#80808042', marginRight: '5px' }} />
}
useEffect(()=>{
  if(globalState.soldTickets.failed){
    setErrorActiveTab(3)
  } 
},[globalState.soldTickets.failed])


  const handleChange = (event:any) => {
    const tempData = {...globalState}
    setSelectedValue(event.target.value);
    tempData.errorStatus.addTicket = event.target.value
    setCurrentPage(1);
    if(errorActiveTab === 0){
      tempData.errorStatus.addTicket = event.target.value
      setCurrentPage(1);
    }else if(errorActiveTab === 1){
      tempData.errorStatus.publishTicket = event.target.value
      setCurrentPagePublish(1);
    }else if(errorActiveTab === 2){
      tempData.errorStatus.soldTicket = event.target.value
      setCurrentPageSold(1);
    }else if(errorActiveTab === 4){
      tempData.errorStatus.stripePayout = event.target.value
      setCurrentPageStripepayout(1);
      if(event.target.value==="Failed"){
        setColumnTypesForStripepayout('pe_created_at');
      }else{
        setColumnTypesForStripepayout('ps_created_at');
      }
    }
    handleGlobalState(tempData)
  };


  return (
    <ThemeProvider theme={errorDashboardTheme}>
      <div className={styles.errorMainContainer}>
        <div className={styles.errorContainer}>
          <div className={styles.TabsStyle}>
            <Tabs value={errorActiveTab} onChange={handleChangeErrorActiveTab} 
            variant='scrollable'
            scrollButtons={false}
              >
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {emailOutlinedIcon(0)}
                    <span>Add Tickets</span>
                  </div>
                }
              />
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {emailOutlinedIcon(1)}
                    <span>Publish Tickets</span>
                  </div>
                }
              />              
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {emailOutlinedIcon(2)}
                    <span>Sold Tickets</span>
                  </div>
                }
              />
              {canViewMailParserExtendedTabs(globalState.profile.userRole) && 
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {stripeOutlinedIcon(3)}
                    <span>Transfer</span>
                  </div>
                }
              />}
               {canViewMailParserExtendedTabs(globalState.profile.userRole) && 
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {stripeOutlinedIcon(4)}
                    <span>Payout</span>
                  </div>
                }
              />}
               {canViewMailParserExtendedTabs(globalState.profile.userRole) && 
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {UserTicketsIcon(5)}
                    <span>User Tickets</span>
                  </div>
                }
              />}
              {/* <Tab label={"Scrap Events"}/> */}
            </Tabs>
          </div>

          <div className={styles.calenderContainer}>
            {(errorActiveTab === 0 || errorActiveTab === 1||errorActiveTab === 2||errorActiveTab===4) && (
              <div className={styles.statusDropdown}>
                <FormControl>
                  <CustomSelect
                    value={
                      errorActiveTab === 0
                        ? globalState.errorStatus.addTicket
                        : errorActiveTab === 1
                        ? globalState.errorStatus.publishTicket
                        : errorActiveTab === 2
                        ? globalState.errorStatus.soldTicket
                        : errorActiveTab===4
                        ? globalState.errorStatus.stripePayout
                        : 1
                    }
                    onChange={handleChange}
                    displayEmpty
                    classes={{
                      root:
                        errorActiveTab === 0
                          ? globalState.errorStatus.addTicket === "Success"
                            ? styles.dropdownSuccess
                            : styles.dropdownFailure
                          : errorActiveTab === 1
                          ? globalState.errorStatus.publishTicket === "Success"
                            ? styles.dropdownSuccess
                            : styles.dropdownFailure
                          : errorActiveTab === 2
                          ? globalState.errorStatus.soldTicket === "Success"
                              ? styles.dropdownSuccess
                              : styles.dropdownFailure
                          : errorActiveTab === 4
                          ? globalState.errorStatus.stripePayout === "Success"
                            ? styles.dropdownSuccess
                            : styles.dropdownFailure
                          : "",
                    }}
                    inputProps={{ "aria-label": "Select" }}
                  >
                    {/* <MenuItem
                      value=""
                      disabled
                      classes={{
                        root: styles.dropdownMenuItem,
                      }}
                    >
                      -Select-
                    </MenuItem> */}
                    <MenuItem
                      value="Success"
                      classes={{
                        root: styles.dropdownMenuItemSuccess,
                        selected: styles.selectedMenuItem,
                      }}
                    >
                      Success
                    </MenuItem>
                    <MenuItem
                      value="Failed"
                      classes={{
                        root: styles.dropdownMenuItemFailed,
                        selected: styles.selectedMenuItem,
                      }}
                    >
                      Failure
                    </MenuItem>
                  </CustomSelect>
                </FormControl>
              </div>
            )}
            {/* {(globalState?.soldTickets.errorcount !== 0 && globalState.soldTickets.failed  ) && <div className={styles.filterResultCount}>Failed Results<span className={styles.filterCount}>({globalState?.soldTickets?.errorcount})</span></div>} */}
            <div className={styles.labelCalender}>
              <div className={styles.sideHeading}>
                <span className={styles.FromLabelStyle}>{`From`}</span>
              </div>
              <DateInputWithForm
                name={"fromDate"}
                showIcon={true}
                // selectedDate={errorActiveTab === 0 ? selectedStartDate : selectedStartDateForSoldError}
                selectedDate={setSelectedDateValue("fromdate")}
                onChangeDate={(e) =>
                  dateValidation(e, "fromDate", errorActiveTab)
                }
                showPopperArrow={false}
                control={control}
              />
            </div>
            <div className={styles.labelCalender}>
              <div className={styles.sideHeading}>{`To`}</div>
              <DateInputWithForm
                name={"toDate"}
                showIcon={true}
                // selectedDate={errorActiveTab === 0 ? selectedEndDate : selectedEndDateForSoldError}
                selectedDate={setSelectedDateValue("todate")}
                onChangeDate={(e) =>
                  dateValidation(e, "toDate", errorActiveTab)
                }
                showPopperArrow={false}
                control={control}
              />
            </div>
          </div>
        </div>
        {/* {errorMessage && <div className={styles.noErrorData}>{errorMessage}</div>} */}
        {errorActiveTab === 0 && (
          <AddTicketsError
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            checking={checking}
            setChecking={setChecking}
            addTicketErrorList={addTicketErrorList}
            setAddTicketErrorList={setAddTicketErrorList}
            columnTypes={columnTypesForAdd}
            setColumnTypes={setColumnTypesForAdd}
            sortType={sortType}
            setSortType={setSortType}
            selected={selected}
            setSelected={setSelected}
            datesForApiCall={datesForApiCall}
            selectedStartDate={selectedStartDate}
            selectedEndDate={selectedEndDate}
            GenerateAddTicketsErrorHeadCells={GenerateAddTicketsErrorHeadCells}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handlePageChange={handlePageChange}
          />
        )}
        {/* {(errorActiveTab === 1) && <PublishTicketsError/>} */}
        {errorActiveTab === 1 && (
          <PublishTicketsError
            rowsPerPagePublish={rowsPerPagePublish}
            currentPagePublish={currentPagePublish}
            setCurrentPagePublish={setCurrentPagePublish}
            checking={checking}
            setChecking={setChecking}
            publishTicketErrorList={publishTicketErrorList}
            setPublishTicketErrorList={setPublishTicketErrorList}
            columnTypes={columnTypesForPublish}
            setColumnTypes={setColumnTypesForPublish}
            sortType={sortType}
            setSortType={setSortType}
            selected={selected}
            setSelected={setSelected}
            datesForApiCall={datesForApiCallForPublishError}
            selectedStartDate={selectedStartDateForPublishError}
            selectedEndDate={selectedEndDateForPublishError}
            GeneratePublishTicketsErrorHeadCells={
              GeneratePublishTicketsErrorHeadCells
            }
            handleChangeRowsPerPagePublish={handleChangeRowsPerPageForPublishTicket}
            handlePageChangePublish={handlePageChangePublishTicket}
          />
        )}
        {errorActiveTab === 2 && (
          <SoldTicketsError
            rowsPerPageSold={rowsPerPageSold}
            currentPageSold={currentPageSold}
            setCurrentPageSold={setCurrentPageSold}
            checking={checking}
            setChecking={setChecking}
            soldTicketErrorList={soldTicketErrorList}
            setSoldTicketErrorList={setSoldTicketErrorList}
            columnTypes={columnTypesForSold}
            setColumnTypes={setColumnTypesForSold}
            sortType={sortType}
            setSortType={setSortType}
            selected={selected}
            setSelected={setSelected}
            datesForApiCall={datesForApiCallForSoldError}
            selectedStartDate={selectedStartDateForSoldError}
            selectedEndDate={selectedEndDateForSoldError}
            GenerateSoldTicketsErrorHeadCells={
              GenerateSoldTicketsErrorHeadCells
            }
            handleChangeRowsPerPageSold={handleChangeRowsPerPageForSoldTicket}
            handlePageChangeSold={handlePageChangeSoldTicket}
          />
        )}
        {(errorActiveTab === 3 && canViewMailParserExtendedTabs(globalState.profile.userRole)) && (
          <StripePaymentsError
            rowsPerPageStripe={rowsPerPageStripe}
            currentPageStripe={currentPageStripe}
            setCurrentPageStripe={setCurrentPageStripe}
            checking={checking}
            setChecking={setChecking}
            stripePaymentsErrorList={stripePaymentsErrorList}
            setStripePaymentsErrorList={setStripePaymentsErrorList}
            columnTypes={columnTypesForStripe}
            setColumnTypes={setColumnTypesForStripe}
            sortType={sortType}
            setSortType={setSortType}
            selected={selected}
            setSelected={setSelected}
            datesForApiCall={datesForApiCallForStripeError}
            selectedStartDate={selectedStartDateForStripeError}
            selectedEndDate={selectedEndDateForStripeError}
            GenerateStripePaymentsErrorHeadCells={
              GenerateStripePaymentsErrorHeadCells
            }
            handleChangeRowsPerPageStripe={handleChangeRowsPerPageForStripe}
            handlePageChangeStripe={handlePageChangeStripe}
            setDatesForApiCallForStripeError={setDatesForApiCallForStripeError}
          />
        )}
        {(errorActiveTab === 4 && canViewMailParserExtendedTabs(globalState.profile.userRole)) && (
          <StripePayoutError
            rowsPerPageStripepayout={rowsPerPageStripepayout}
            currentPageStripepayout={currentPageStripepayout}
            setCurrentPageStripepayout={setCurrentPageStripepayout}
            checking={checking}
            setChecking={setChecking}
            stripePaymentsErrorpayoutList={stripePaymentsErrorpayoutList}
            setStripePaymentspayoutErrorList={setStripePaymentspayoutErrorList}
            columnTypes={columnTypesForStripepayout}
            setColumnTypes={setColumnTypesForStripepayout}
            sortType={sortType}
            setSortType={setSortType}
            selected={selected}
            setSelected={setSelected}
            datesForApiCall={datesForApiCallForStripepayoutError}
            selectedStartDate={selectedStartDateForStripepayoutError}
            selectedEndDate={selectedEndDateForStripepayoutError}
            GenerateStripePayoutErrorHeadCells={
              globalState?.errorStatus.stripePayout==="Failed"?GenerateStripePayoutErrorHeadCells:GenerateStripePayoutSuccessHeadCells
            }
            handleChangeRowsPerPageForStripepayout={
              handleChangeRowsPerPageForStripepayout
            }
            handlePageChangeStripepayout={handlePageChangeStripepayout}
            setDatesForApiCallForStripepayoutError={
              setDatesForApiCallForStripepayoutError
            }
          />
        )}
        {errorActiveTab === 5 && (
          <UserTicketsLog
            rowsPerPage={rowsPerPageManualTicket}
            currentPage={currentPageManualTicket}
            setCurrentPage={setCurrentPageManualTicket}
            checking={checking}
            setChecking={setChecking}
            manualTicketErrorList={manualTicketErrorList}
            setManualTicketErrorList={setManualTicketErrorList}
            columnTypes={columnTypesForManualTickets}
            setColumnTypes={setColumnTypesForManualTickets}
            sortType={sortType}
            setSortType={setSortType}
            selected={selected}
            setSelected={setSelected}
            datesForApiCall={datesForApiCallForManualTicketsError}
            selectedStartDate={selectedStartDateForManualTicketError}
            selectedEndDate={selectedEndDateForManualTicketError}
            GenerateManualTicketsErrorHeadCells={
              GenerateManualTicketsErrorHeadCells
            }
            handleChangeRowsPerPage={handleChangeRowsPerPageForManualTickets}
            handlePageChange={handlePageChangeManualTicket}
          />
        )}
        {errorActiveTab === 6 && (
          <ScrapeEventError
            rowsPerPageScrape={rowsPerPageScrape}
            currentPageScrape={currentPageScrape}
            setCurrentPageScrape={setCurrentPageScrape}
            checking={checking}
            setChecking={setChecking}
            scrapeEventErrorList={scrapeEventErrorList}
            setScrapeEventErrorList={setScrapeEventErrorList}
            columnTypes={columnTypesForScrape}
            setColumnTypes={setColumnTypesForScrape}
            sortType={sortType}
            setSortType={setSortType}
            selected={selected}
            setSelected={setSelected}
            datesForApiCall={datesForApiCallForScrapeError}
            selectedStartDate={selectedStartDateForScrapeError}
            selectedEndDate={selectedEndDateForScrapeError}
            GenerateScrapeEventErrorHeadCells={
              GenerateScrapeEventErrorHeadCells
            }
            handleChangeRowsPerPageForScrape={handleChangeRowsPerPageForScrape}
            handlePageChangeScrape={handlePageChangeScrape}
          />
        )}
      </div>
    </ThemeProvider>
  );
}

export default ErrorDashboard